export default __webpack_public_path__ + "static/media/mission-bg.466511dd.jpg";